import React, { Component } from "react";
import history from "../../pages/login/history";
import { formatoSeparadorMilesValue} from '../../generico/utils/FormatoInput'
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHand } from "@fortawesome/free-solid-svg-icons";

export default class PrestamoPreaprobadoBanner extends Component {
    constructor(props) {
        super(props);
       
    }

    componentDidMount() {
    }

    prestamoPreAprobado = () => {
        sessionStorage.setItem("saldoLinea", this.props.preaprobado[0].saldoLinea);

        //history.push('/solicitudPrestamoPreaprobado');
        history.push(ConfigService.getPathByName("solicitudPrestamoPreaprobado")?.url);
        window.location.reload();
    }    

    render() {
        return (    
            <div>      
                {(this.props.preaprobado.length>0 && this.props.preaprobado[0].saldoLinea >=500000 ) && ( 
                    <div className="card banner-preaprobado">
                        <div className="card-body" style={{padding: "1rem"}}>
                            <div className="row">  
                                <div className="col-md-12 col-descripcion">
                                    <div className="row">
                                       
                                        <div className="col-md-9">
                                            <h5 className="texto-credito">Tenés un Crédito Aprobado</h5>
                                            <p className="texto-banner"> de {formatoSeparadorMilesValue(this.props.preaprobado[0].saldoLinea)} gs</p>
                                        </div>  
                                        <div className="col-md-3" style={{paddingTop: 15}}>
                                    <button className="btn btn-light btn-ingresar btn-block m-auto" onClick={this.prestamoPreAprobado}>
                                       <FontAwesomeIcon icon={faHand} /> Quiero
                                    </button>
                                </div> 
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                )}    
            </div>  
        );   
    }
}
